import React, { useEffect, useState } from "react";
import { useAxios } from "../../../common_nextgen/axios/AxiosHelper";
import useCustomNavigate from "../../../common_nextgen/common_components/Navigation/NextGenNavigation";
import getBackendUrl from "../../../environment/BackendService";
import { fetchDropdownValues } from "../../../common_nextgen/common_components/dropdown/DropdownHelper";
import { useLocation } from "react-router-dom";
import {
  LEGACY_SCREEN_VIEW,
  ROUTE_PATHS,
} from "../../../common_nextgen/utils/Constants";
import { useToast } from "../../../common_nextgen/hooks/ToastContext";
import { IndicatorCell } from "../../../common_nextgen/common_components/IndicatorCell/IndicatorCell";
import { getHideToggleMenuItem } from "../../../common_nextgen/common_components/MenuItemButton/MenuItemButton";
import {
  downloadCSV,
  navigateToPresto,
} from "../../../common_nextgen/utils/UtilFunctions";

const defaultParamData = {
  ps4PtPaySchTableName: "",
  ps4PatPayDescription: "",
  hiddenRecordIndicator: "Active",
};

const usePatientPayTable = (
  onSelect,
  hideModal,
  selectParams,
  selectMode,
  lookupType,
  selectParamsData,
  onNavigate
) => {
  const { axios_helper_no_header } = useAxios();
  const [data, setData] = useState([]); /* Patient Pay Table Data */

  const location = useLocation();
  const stateVal = location.state ?? [];
  const [currentState = {}] = [...stateVal].reverse();
  const previousState = [...stateVal];
  previousState.splice(stateVal.length - 1, 1);

  const {
    currentIndex: initialIndex = 0,
    paramsData: initialParamsData = defaultParamData,
    showMinMaxModel = false,
  } = currentState;

  const initialParamsDataWithStatus = {
    ...initialParamsData,
    hiddenRecordIndicator: initialParamsData.hiddenRecordIndicator || "Active",
  };
  const baseParamsData = lookupType
    ? { ...defaultParamData, ...selectParamsData }
    : initialParamsDataWithStatus;

  console.log("base", baseParamsData);
  const [paramsData, setParamsData] = useState(baseParamsData);

  const [currentIndex, setCurrentIndex] = useState(initialIndex);
  const [first, setFirst] = useState(0);
  const [rows, setRows] = useState(10);
  const [totalRecords, setTotalRecords] = useState(0);

  const [currentPage, setCurrentPage] = useState(0);

  const navigateToPage = useCustomNavigate();
  const [dropdownValues, setDropdownValues] = useState({});

  const [isConfirmationModalOpen, setIsConfirmationModalOpen] = useState(false);
  const openConfirmationModal = () => {
    setIsConfirmationModalOpen(true);
  };

  const [selectedOption, setSelectedOption] = useState("no");

  const [isHideConfirmationModalOpen, setIsHideConfirmationModalOpen] =
    useState(false);
  const openHideConfirmationModal = () => {
    setIsHideConfirmationModalOpen(true);
  };

  const [hideSelectedOption, setHideSelectedOption] = useState("no");
  const [hideFlag, setHideFlag] = useState(false);
  const toast = useToast();
  const [selectedRows, setSelectedRows] = useState(
    location.state !== null &&
      Array.isArray(location.state) &&
      location.state.length > 0 &&
      location.state[0] &&
      location.state[0].hasOwnProperty("selectedSchedules")
      ? location.state[0]["selectedSchedules"]
      : []
  );
  const [rowData, setRowData] = useState(
    selectedRows.length === 1 ? selectedRows[0] : ""
  );
  const [previousScreen, setPreviousScreen] = useState(location.pathname);
  const [paramsDataForMinMax, setParamsDataForMinMax] = useState(
    showMinMaxModel ? paramsData : {}
  );
  const {
    ADD_PATIENT_PAY_TABLE,
    EDIT_PATIENT_PAY_TABLE,
    DISPLAY_PATIENT_PAY_TABLE,
    COPY_PATIENT_PAY_TABLE,
    PATIENT_PAY_TABLE_NOTE,
    MIN_MAX_COPAY_STEP,
    MIN_MAX_DIFFERENTIAL,
    MIN_MAX_COPAY_DIFFERENTIAL,
    ADD_PATIENT_PAY_TABLE_DETAIL,
    EDIT_PATIENT_PAY_TABLE_DETAIL,
    DISPLAY_PATIENT_PAY_TABLE_DETAIL,
    ADD_PATIENTPAY_TABLE_ADDIITIONAL_SCHEDULE,
  } = ROUTE_PATHS;

  const screen_title = "Patient Pay Table";
  const screenNumber = selectMode ? "RCPS4035" : "RCPS4031";

  /* Search form fields that needs to be shown for filtering */
  const formFields = [
    {
      fieldLabel: "PS4 Pt Pay Sch Table Name",
      name: "ps4PtPaySchTableName",
      label: "Table",
      type: "text",
      fieldNature: "editable",
      value: "",
      maxLength: 13,
    },
    {
      fieldLabel: "PS4 Pat Pay Description",
      name: "ps4PatPayDescription",
      label: "Description",
      type: "text",
      fieldNature: "editable",
      value: "",
      maxLength: 25,
    },
    {
      fieldLabel: "Hidden Record IndicatorValid Values",
      name: "hiddenRecordIndicator",
      label: "Status",
      type: "dropdown",
      fieldNature: "editable",
      value: "",
      maxLength: 1,
    },
  ];

  /* Dropdown options fields that needs to be fetched with API */
  const dropdownOptions = [
    { field_label: "Hidden Record Indicator", condition: "Valid Values" },
  ];

  const dropdownCondition = {
    dropDowns: dropdownOptions.map((item) => item.field_label + item.condition),
  };

  const handleBack = () => {
    hideModal();
  };

  const leftButtons = selectMode
    ? [{ button_label: "Back", button_handeler: handleBack, button_key: "F12" }]
    : [];

  /* ACTION BUTTONS info that needs to be displayed on the page */
  const ctaButtons = selectMode
    ? []
    : [
        {
          button_label: "Add Patient Pay Table",
          button_handeler: () => {
            navigateToPage(ADD_PATIENT_PAY_TABLE_DETAIL, [
              {
                previousScreen: location.pathname,
              },
            ]);
          },
          button_key: "F6",
        },
        {
          button_label: "Export as CSV",
          button_handeler: () => {
            exportAsCSV();
          },
          button_key: "",
        },
      ];

  const [dialogVisible, setDialogVisible] = useState(
    location.state !== null &&
      Array.isArray(location.state) &&
      location.state.length > 0 &&
      location.state[0] &&
      location.state[0].hasOwnProperty("modal")
      ? location.state[0]["modal"]
      : false
  );

  // if

  /* Gear Icon Menu option CTAs */
  const menuOptions = selectMode
    ? [
        {
          label: "Select",
          icon: <span className="material-icons">add</span>,
          command: () => {
            const paramData = selectParams.reduce((acc, key) => {
              if (rowData.hasOwnProperty(key["target"])) {
                acc[key["source"]] = rowData[key["target"]];
              }
              return acc;
            }, {});
            if (lookupType !== "external") {
              onSelect(paramData);
            } else {
              window.parent.postMessage(paramData);
            }
          },
        },
        {
          label: "Display",
          icon: <span className="material-icons">visibility</span>,
          command: () => {
            const { ps4PtPaySchTableName } = rowData || {};
            /* navigateToPresto(LEGACY_SCREEN_VIEW.RCPS4005I, {
              ps4PtPaySchTableName,
              tcdFinalPlanEffDte: "",
              tcdFinalPlanCde: "",
              pdtRblPatientSchedNme: "",
              pdtRblPatientSchedTbl: ""
            });*/
            onNavigate({
              data: { ...rowData },
              target: ROUTE_PATHS.DISPLAY_PATIENT_PAY_TABLE_DETAIL,
              navType: "local",
            });
          },
        },
        {
          label: "Min/Max",
          icon: <span className="material-icons">search</span>,
          command: () => {
            /*  const {
              ps4GenrcCopayCalccode,
              ps4BrandCopayCalccode,
              ps4PatPayDescription,
              ps4PtPaySchTableName,
            } = rowData || {};
            navigateToPresto(LEGACY_SCREEN_VIEW.RCPTF009, {
              workInitialProgramMode: "DSP",
              ps4GenrcCopayCalccode,
              ps4BrandCopayCalccode,
              ps4PatPayDescription,
              ps4PtPaySchTableName,
            });*/
            /* onNavigate({
               data: { ...rowData },
               target: ROUTE_PATHS.MIN_MAX_COPAY_STEP,
               navType: "local",
             });*/
            const lastRecord = selectedRows.length
              ? selectedRows[selectedRows.length - 1]
              : rowData;
            const { ps4PtPaySchTableName } = lastRecord;
            const updatedParamsData = {
              ...paramsData,
              ps4PtPaySchTableName: ps4PtPaySchTableName,
            };
            setParamsDataForMinMax(updatedParamsData);
            setDialogVisible(true);
          },
        },
        {
          label: "Additional",
          icon: <span className="material-icons">more_horiz</span>,
          command: () => {
            /* const { ps4PtPaySchTableName = "", ps4PatPayDescription = "" } =
              rowData || {};
            navigateToPresto(LEGACY_SCREEN_VIEW.RCAPP001I, {
              ps4PatPayDescription,
              ps4PtPaySchTableName,
            }); */
            if (rowData.additionalPPExists === "P") {
              onNavigate({
                data: { ...rowData },
                target:
                  ROUTE_PATHS.DISPLAY_PATIENTPAY_TABLE_ADDIITIONAL_SCHEDULE,
                navType: "local",
                schedulesDataKey: "selectedSchedules",
              });
            } else {
              toast.current.show({
                severity: "error",
                summary: "",
                detail: "Additional Patient pay does not exist",
                life: 3000,
              });
            }
          },
        },
      ]
    : [
        {
          label: "Note",
          icon: <span className="material-icons">note</span>,
          command: () => {
            navigateToPage(PATIENT_PAY_TABLE_NOTE, [
              {
                selectedPatients: selectedRows.length
                  ? selectedRows
                  : [rowData],
                previousScreen: location.pathname,
              },
            ]);
          },
        },
        {
          label: "Edit",
          icon: <span className="material-icons">edit</span>,
          command: () => {
            navigateToPage(EDIT_PATIENT_PAY_TABLE_DETAIL, [
              {
                selectedPatients: selectedRows.length
                  ? selectedRows
                  : [rowData],
                previousScreen: location.pathname,
                currentIndex: 0,
              },
            ]);
          },
        },
        {
          label: "Copy",
          icon: <span className="material-icons">content_copy</span>,
          command: () => {
            navigateToPage(COPY_PATIENT_PAY_TABLE, [
              {
                selectedPriceSchedules: selectedRows.length
                  ? selectedRows
                  : [rowData],
                previousScreen: location.pathname,
              },
            ]);
          },
        },
        {
          label: "Delete",
          icon: <span className="material-icons">delete</span>,
          command: () => {
            openConfirmationModal();
          },
        },
        {
          label: "Display",
          icon: <span className="material-icons">visibility</span>,
          command: () => {
            navigateToPage(DISPLAY_PATIENT_PAY_TABLE_DETAIL, [
              {
                selectedPatients: selectedRows.length
                  ? selectedRows
                  : [rowData],
                previousScreen: location.pathname,
              },
            ]);
          },
        },
        getHideToggleMenuItem(
          rowData.hiddenRecordIndicator,
          openHideConfirmationModal
        ),
        {
          label: "Min/Max",
          icon: <span className="material-icons">search</span>,
          command: () => {
            const lastRecord = selectedRows.length
              ? selectedRows[selectedRows.length - 1]
              : rowData;
            const { ps4PtPaySchTableName } = lastRecord;
            const updatedParamsData = {
              ...paramsData,
              ps4PtPaySchTableName: ps4PtPaySchTableName,
            };
            setParamsDataForMinMax(updatedParamsData);
            setDialogVisible(true);
          },
        },
        {
          label: "Additional",
          icon: <span className="material-icons">more_horiz</span>,
          command: () => {
            const lastRecord = selectedRows.length
              ? selectedRows[selectedRows.length - 1]
              : rowData;
            const { ps4PtPaySchTableName } = lastRecord;
            const updatedParamsData = {
              ...paramsData,
              ps4PtPaySchTableName: ps4PtPaySchTableName,
            };
            if (selectedRows.length) {
              for (let i = 0; i < selectedRows.length; i++) {
                console.log(" selectedRows[i] ->", selectedRows[i]);
                const routePath =
                  selectedRows[i].additionalPPExists === "P"
                    ? ROUTE_PATHS.EDIT_PATIENTPAY_TABLE_ADDIITIONAL_SCHEDULE
                    : ROUTE_PATHS.ADD_PATIENTPAY_TABLE_ADDIITIONAL_SCHEDULE;
                navigateToPage(routePath, [
                  { paramsData: updatedParamsData },
                  {
                    selectedSchedules: selectedRows,
                    previousScreen: location.pathname,
                    paramsData,
                  },
                ]);
              }
            } else {
              const routePath =
                [rowData][0].additionalPPExists == "P"
                  ? ROUTE_PATHS.EDIT_PATIENTPAY_TABLE_ADDIITIONAL_SCHEDULE
                  : ROUTE_PATHS.ADD_PATIENTPAY_TABLE_ADDIITIONAL_SCHEDULE;
              navigateToPage(routePath, [
                { paramsData: updatedParamsData },
                {
                  selectedSchedules: [rowData],
                  previousScreen: location.pathname,
                  paramsData,
                },
              ]);
            }
          },
        },
      ].filter((menuItem) => menuItem !== undefined);

  /* Data table column info. */
  const columnDef = [
    {
      header: "Table",
      field: "ps4PtPaySchTableName",
    },
    {
      header: "Description",
      field: "ps4PatPayDescription",
    },

    {
      header: "Indicators",
      field: "noteExistenceStatus",
      body: (rowData) => (
        <IndicatorCell
          rowData={rowData}
          fields={["additionalPPExists", "minMaxExists", "noteExistenceStatus"]}
          tooltipContent={{additionalPPExists: "Additional", minMaxExists: "Min Max", noteExistenceStatus: "Notes"}}
        />
      ),
    },
    {
      header: "Status",
      field: "hiddenRecordIndicator",
    },
  ];

  /* Param Key which used as bridge between various operations on tabluar data */
  const parmKey = "counter";

  /* Handler that fetches the data */
  const fetchData = async () => {
    const page = first / rows;
    try {
      const raw_response = await axios_helper_no_header(
        "GET",
        `api/ps4PatientPaySchTable`,
        null,
        {
          page: page,
          size: rows,
          ...paramsData,
        }
      );
      const response = raw_response.responseData;
      const pageResponse = raw_response.responsePaginationDTO;
      if (response.length === 0) {
        setData([]);
        setTotalRecords(0);
        toast.current.show({
          severity: "info",
          summary: "",
          detail: response.responseStatus.message,
          life: 3000,
        });
      } else {
        setData(response);
        setTotalRecords(pageResponse.totalRecords); // Assuming the API returns totalRecords
      }
    } catch (error) {
      console.error("Error fetching data:", error);
      setData([]);
      setTotalRecords(0);
    }
  };

  const fetchDropdownData = async (dataDropdown) => {
    try {
      const response = await fetchDropdownValues(dataDropdown);
      setDropdownValues(response);
    } catch (error) {
      console.error("Error fetching dropdown values:", error);
    }
  };

  useEffect(() => {
    fetchDropdownData(dropdownCondition);
  }, []);

  useEffect(() => {
    fetchData(); // Initial fetch with page 0 and page size 10
  }, [paramsData, rows, currentPage, hideFlag]);

  useEffect(() => {
    if (showMinMaxModel && data?.length) {
      setRowData(data[0]);
      setDialogVisible(true);
      delete currentState["showMinMaxModel"];
    }
  }, [showMinMaxModel, data]);

  const onPageChange = (event) => {
    setFirst(event.first);
    setCurrentPage(event.page);
    setRows(event.rows);
  };

  const closeConfirmationModal = () => {
    setIsConfirmationModalOpen(false);
    setSelectedOption("no");
  };

  const closeHideConfirmationModal = () => {
    console.log(hideSelectedOption);
    setIsHideConfirmationModalOpen(false);
    setHideSelectedOption("no");
  };

  const hidePatientPayTable = () => {
    if (hideSelectedOption === "yes") {
      let ps4PtPaySchTableNameList = [];

      if (Array.isArray(selectedRows) && selectedRows.length > 0) {
        ps4PtPaySchTableNameList = selectedRows.map(
          (row) => row.ps4PtPaySchTableName
        );
      } else if (rowData && Object.keys(rowData).length > 0) {
        ps4PtPaySchTableNameList[0] = rowData.ps4PtPaySchTableName;
      }
      if (ps4PtPaySchTableNameList.length > 0) {
        const params = {
          screenNumber: screenNumber,
        };
        axios_helper_no_header(
          "PUT",
          "api/ps4PatientPaySchTable/hidePatientPayTable",
          ps4PtPaySchTableNameList,
          params
        )
          .then((response) => {
            const updatedItems = data.filter(
              (item) => item[parmKey] !== rowData
            );
            setTotalRecords((prevTotal) => prevTotal - 1);
            setData(updatedItems);
            toast.current.show({
              severity: "success",
              summary: "",
              detail: response.responseStatus.message,
              life: 3000,
            });
            setHideFlag(!hideFlag);
            closeHideConfirmationModal();
          })
          .catch((error) => {
            console.error("There was an error hiding the data!", error);
            toast.current.show({
              severity: "error",
              summary: "",
              detail: error.message,
              life: 3000,
            });
            closeHideConfirmationModal();
          });
      } else {
        closeHideConfirmationModal();
      }
    }
  };

  const deletePatientPayTable = () => {
    if (selectedOption === "yes") {
      let ps4PtPaySchTableNameList = [];

      if (Array.isArray(selectedRows) && selectedRows.length > 0) {
        ps4PtPaySchTableNameList = selectedRows.map(
          (row) => row.ps4PtPaySchTableName
        );
      } else if (rowData && Object.keys(rowData).length > 0) {
        ps4PtPaySchTableNameList[0] = rowData.ps4PtPaySchTableName;
      }
      if (ps4PtPaySchTableNameList.length > 0) {
        axios_helper_no_header(
          "DELETE",
          "api/ps4PatientPaySchTable",
          ps4PtPaySchTableNameList,
          null
        )
          .then((response) => {
            const updatedItems = data.filter(
              (item) => item[parmKey] !== rowData
            );
            setTotalRecords((prevTotal) => prevTotal - 1);
            setData(updatedItems);
            // fetchData();
            if (currentPage > 0) {
              setFirst(0);
              setCurrentPage(0);
            } else {
              fetchData();
            }
            toast.current.show({
              severity: "success",
              summary: "",
              detail: response.responseStatus.message,
              life: 3000,
            });
            closeConfirmationModal();
          })
          .catch((error) => {
            console.error("There was an error deleting the data!", error);
            const {
              responseStatus: { displayErrorFields = null, message } = {},
            } = error.data;
            toast.current.show({
              severity: "error",
              summary: "",
              detail: message,
              life: 3000,
            });
            closeConfirmationModal();
          });
      } else {
        closeConfirmationModal();
      }
    }
  };

  const exportAsCSV = async () => {
    const queryParams = new URLSearchParams({ ...paramsData });

    try {
      const response = await axios_helper_no_header(
        "GET",
        "api/ps4PatientPaySchTable/exportCsv",
        null,
        queryParams,
        "blob"
      );
      downloadCSV(response);
    } catch (error) {
      console.error("Error exporting as CSV:", error);
      toast.current.show({
        severity: "error",
        summary: "",
        detail: "Failed to export CSV. Please try again.",
        life: 3000,
      });
    }
  };

  const updateParamData = (data) => {
    setFirst(0);
    setCurrentPage(0);
    setParamsData(data);
  };

  return {
    screenNumber,
    screen_title,
    formFields,
    dropdownValues,
    paramsData,
    updateParamData,
    ctaButtons,
    data,
    dialogVisible,
    setDialogVisible,
    parmKey,
    menuOptions,
    leftButtons,
    selectMode,
    columnDef,
    rowData,
    setRowData,
    selectedRows,
    previousScreen,
    setSelectedRows,
    first,
    rows,
    totalRecords,
    currentPage,
    onPageChange,
    isConfirmationModalOpen,
    closeConfirmationModal,
    deletePatientPayTable,
    hidePatientPayTable,
    setSelectedOption,
    isHideConfirmationModalOpen,
    closeHideConfirmationModal,
    setHideSelectedOption,
    paramsDataForMinMax,
  };
};

export default usePatientPayTable;
